export const CREATE_VEHICLE = "CREATE_VEHICLE";
export const FETCH_VEHICLES = "FETCH_VEHICLES";
export const FETCH_VEHICLE = "FETCH_VEHICLE";
export const EDIT_VEHICLE = "EDIT_VEHICLE";
export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const FETCH_VEHICLE_DLL = "FETCH_VEHICLE_DLL";
